
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@material-ui/core";

import React from "react";

import {useTranslation} from "react-i18next";

import version from "../version.json";
import CloseableDialog from "./closeable";

export function AboutDialog({open, aboutComplete}) {
    const {t} = useTranslation();

    return <CloseableDialog open={open} onClose={aboutComplete} dialogTitle={t("RSJ 3D Packer")}>

            <DialogContent>
                <Typography>{t("Version")}: {version}</Typography>
                <Typography>{t("(C) Copyright 2020-2022 by RSJ Software GmbH Germering.")}</Typography>
                <Typography>{t("All rights reserved.")}</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={aboutComplete} color="primary">{t("OK")}</Button>
            </DialogActions>
        </CloseableDialog>;
    }

export default AboutDialog;